// Dimension Types for Accounting Reports
export const DIMENSION_TYPES = {
  CUSTOMER: 'Customer',
  VENDOR: 'Vendor',
  COST_CENTER: 'CostCenter',
  PRODUCT: 'Product',
  JOB: 'Job',
  CUSTOM_1: 'Custom1',
  CUSTOM_2: 'Custom2',
  CUSTOM_3: 'Custom3'
} as const;

export type DimensionType = typeof DIMENSION_TYPES[keyof typeof DIMENSION_TYPES];

// Array for select options with display names
export const DIMENSION_TYPE_OPTIONS = [
  { value: DIMENSION_TYPES.CUSTOMER, label: 'Customer' },
  { value: DIMENSION_TYPES.VENDOR, label: 'Vendor' },
  { value: DIMENSION_TYPES.COST_CENTER, label: 'Cost Center' },
  { value: DIMENSION_TYPES.PRODUCT, label: 'Product' },
  { value: DIMENSION_TYPES.JOB, label: 'Job' },
  { value: DIMENSION_TYPES.CUSTOM_1, label: 'Custom 1' },
  { value: DIMENSION_TYPES.CUSTOM_2, label: 'Custom 2' },
  { value: DIMENSION_TYPES.CUSTOM_3, label: 'Custom 3' }
] as const;

// Report Types
export const REPORT_TYPES = {
  UNCONSOLIDATED: 'unconsolidated',
  CONSOLIDATED: 'consolidated',
  ENTITY: 'entity',
} as const;

export type ReportType = typeof REPORT_TYPES[keyof typeof REPORT_TYPES];

// Income Statement supports all 3 types
export const INCOME_STATEMENT_TYPE_OPTIONS = [
  { value: REPORT_TYPES.UNCONSOLIDATED, label: 'Unconsolidated' },
  { value: REPORT_TYPES.CONSOLIDATED, label: 'Consolidated' },
  { value: REPORT_TYPES.ENTITY, label: 'Entity' },
];

// Cash Flow only supports 2 types
export const CASH_FLOW_TYPE_OPTIONS = [
  { value: REPORT_TYPES.UNCONSOLIDATED, label: 'Unconsolidated' },
  { value: REPORT_TYPES.CONSOLIDATED, label: 'Consolidated' },
];

// Balance Sheet supports all 3 types (same as Income Statement)
export const BALANCE_SHEET_TYPE_OPTIONS = [
  { value: REPORT_TYPES.UNCONSOLIDATED, label: 'Unconsolidated' },
  { value: REPORT_TYPES.CONSOLIDATED, label: 'Consolidated' },
  { value: REPORT_TYPES.ENTITY, label: 'Entity' },
];

// Comparative Column Types
export const COMPARATIVE_COLUMN_TYPES = {
  MONTH: 'month',
  QUARTER: 'quarter',
  YEAR: 'year',
} as const;

export type ComparativeColumnType = typeof COMPARATIVE_COLUMN_TYPES[keyof typeof COMPARATIVE_COLUMN_TYPES];

export const COMPARATIVE_COLUMN_TYPE_OPTIONS = [
  { value: '', label: 'None' },
  { value: COMPARATIVE_COLUMN_TYPES.MONTH, label: 'Month' },
  { value: COMPARATIVE_COLUMN_TYPES.QUARTER, label: 'Quarter' },
  { value: COMPARATIVE_COLUMN_TYPES.YEAR, label: 'Year' },
];

// Journal Status Types
export const JOURNAL_STATUS_TYPES = {
  ALL: 'all',
  DRAFT: 'draft',
  POSTED: 'posted',
} as const;

export type JournalStatusType = typeof JOURNAL_STATUS_TYPES[keyof typeof JOURNAL_STATUS_TYPES];

export const JOURNAL_STATUS_TYPE_OPTIONS = [
  { value: JOURNAL_STATUS_TYPES.ALL, label: 'All' },
  { value: JOURNAL_STATUS_TYPES.DRAFT, label: 'Draft' },
  { value: JOURNAL_STATUS_TYPES.POSTED, label: 'Posted' },
];
